// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"afcb498e","453":"eb46ad86","732":"9a028e99"}[chunkId] + ".chunk.js";
};